import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { Fulfillment } from '../../__generated__/graphql';
import { useEffect } from 'react';
// @ts-ignore
import { pusherSubscribeObject } from '../../Common/utils/pusher';
import { usePortalPermissions } from '../../Common/hooks/usePortalPermissions';

export const pendingOrderQuery = graphql(`
  query pendingOrders {
    fulfilmentsPendingComplete {
      id
      createdAt
      total
      subtotal
      dispensed
      shipping
      completed
      discounts
      discountCodes
      booked
      consults
      gateway
      items {
        QTY
        ID
        PrescriptionID
      }
      street
      suburb
      state
      postcode
      total
      suburb
      prescriptionIDs
      creatingRole
      creatingRole
      deliveryMethod
      isPayInPerson
      customer {
        id
        given
        dob
        gender
        brand
        mobile
        name
      }
    }
  }
`);

export const usePendingOrdersList = (poll = false) => {
  const { hasPermission } = usePortalPermissions();

  const { data, loading, refetch } = useQuery(pendingOrderQuery, {
    fetchPolicy: 'cache-and-network',
    skip: !hasPermission('fulfill'),
    ...(poll && {
      pollInterval: 60 * 1000,
    }),
  });

  useEffect(() => {
    const { unsubscribe } = pusherSubscribeObject('fulfillment', 'new', () => refetch());

    return () => {
      unsubscribe();
    };
  }, []);
  const qldStates = ["QLD", "SA", "NT", "WA"];

  return {
    loading,
    countQLD: data?.fulfilmentsPendingComplete?.filter(x => qldStates.includes(x?.state??'') && !x?.deliveryMethod?.startsWith('pickup') && x?.deliveryMethod !== 'sameday-strathpine')?.length ?? 0,
    countNonQLD: data?.fulfilmentsPendingComplete?.filter(x => !qldStates.includes(x?.state??'') && !x?.deliveryMethod?.startsWith('pickup') && x?.deliveryMethod !=='sameday-newtown')?.length ?? 0,
    countPickupNonQLD: data?.fulfilmentsPendingComplete?.filter(x => x?.deliveryMethod === 'pickup-newtowndispensary' || x?.deliveryMethod === 'pickup')?.length ?? 0,
    countPickupQLD: data?.fulfilmentsPendingComplete?.filter(x => x?.deliveryMethod ==='pickup-strathpinedispensary')?.length ?? 0,
    countSameDayNonQLD: data?.fulfilmentsPendingComplete?.filter(x => x?.deliveryMethod === 'sameday-newtown')?.length ?? 0,
    countSameDayQLD: data?.fulfilmentsPendingComplete?.filter(x => x?.deliveryMethod ==='sameday-strathpine')?.length ?? 0,
    count: data?.fulfilmentsPendingComplete?.length ?? 0,
    orders: (data?.fulfilmentsPendingComplete ?? []) as Fulfillment[],
    refetch,
  };
};
